import {action, computed, observable, runInAction} from 'mobx'
import {message} from 'antd'
import {json} from '../../../../utils/ajax'
import {setStore} from "../../../../utils/Utils";

class BoutiqueTypeStore {
    @observable loading
    @observable tree
    @observable modal
    @observable editFields
    @observable info
    @observable option
    @observable dragList
    @observable rowData
    @observable expandedLeftRowKeys
    @observable dragState
    @observable categoryPagination
    @observable isShow
    @observable id
    @observable oldContent
    @observable oldCode

    constructor() {
        this.loading = false
        this.modal = 'hide'
        this.editFields = {}
        this.info = []
        this.option = []
        this.dragList = []
        this.tree = []
        this.rowData = {}
        this.expandedLeftRowKeys = []
        this.dragState = false
        this.categoryPagination = {
            current: 0,
            total: 1
        };
        this.isShow = false
        this.id = ''
        this.oldContent = ''
        this.oldCode = ''
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    @action
    getList = async () => {
        this.loading = true
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/type/catalogTreeList`)
        runInAction(() => {
            if (res.status === 0) {
                return
            }
            this.loading = false
            this.tree = Array.isArray(res) ? res : []
        })
    }

    @computed get fields() {
        let fields = {
            content: {value: this.editFields.content},
            code: {value: this.editFields.code}
        }
        return fields
    }

    @action.bound
    onEditFieldChange(changedFields) {
        const fields = {...this.fields, ...changedFields}
        let editFields = {
            content: fields.content.value,
            code: fields.code.value
        }
        this.editFields = editFields
    }

    @action
    showAddFirstBox = (record, option) => {
        if (option === 'update') {
            runInAction(() => {
                this.editFields.content = record.name
                this.editFields.code = record.code
                this.oldContent = record.name
                this.oldCode = record.code
                this.id = record.id
            })
        } else {
            runInAction(() => {
                this.editFields.content = ''
            })
        }
        runInAction(() => {
            this.info = record
            this.option = option
            this.modal = 'show'
        })
    }

    @action
    operation = async (content, info, option) => {
        //新增一级
        runInAction(() => {
            this.loading = true
        })
        if (!info && !option) {
            const data = {
                "code": content.code,
                "name": content.content,
            }
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/type/insertFirstLevelDirectory`, data)
            runInAction(() => {
                if (res.status === 0) {
                    return
                }
                this.editFields = {}
                this.loading = false
                this.modal = 'hide'
                this.getList()
                this.initGetRightTable()
            })
            return
        }
        //同级||下级||修改
        let data = {
            'code': content.code,
            'name': content.content,
            'id': info.id,
            'level': info.level,
            'pId': info.pId,
            'sort': 1
        }
        if (option === 'addSame') {
            await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/type/addSiblingDirectory`, data)
        } else if (option === 'addChild') {
            data.path = info.path
            await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/type/insertSubordinateDirectory`, data)
        } else if (option === 'update') {
            const updateData = {
                'name': content.content,
                'code': content.code,
                'id': info.id,
                'level': info.level,
                'pId': info.pId,
                'path': info.path,
                'sort': info.sort
            }
            if(updateData.name===this.oldContent&&updateData.code===this.oldCode) {
                this.loading = false
                return message.warn('数据相同！')
            }
            await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/type/update`, updateData)
        }
        runInAction(() => {
            this.getList()
            this.loading = false
            this.modal = 'hide'
            this.editFields = {}
            this.rowData.id ? this.clickRow(this.rowData) : this.initGetRightTable()
        })
    }

    @action
    getTableList = async (page, size) => {
        this.loading = true
        let id = this.rowData.id?this.rowData.id:''
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/type/lv1BelowCatalog/${id}`,{
            page: page?page-1:0,
            size: 10
        })
        runInAction(() => {
            if (res.status === 0) {
                this.loading = false
                return
            }
            this.dragList = Array.isArray(res.content) ? res.content : []
            this.categoryPagination = {
                current: res.number + 1,
                total: res.totalElements
            }
            this.loading = false
            this.isShow = true
        })
    }

    @action
    initGetRightTable = async (page) => {
        this.loading = true
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/type/lv1CatalogList`,{
            page: page?page-1:0,
            size: 10
        })
        runInAction(()=> {
            if (res.status === 0) {
                this.loading = false
                return
            }
            this.dragList = Array.isArray(res.content) ? res.content : []
            this.categoryPagination = {
                current: res.number + 1,
                total: res.totalElements
            }
            this.loading = false
            this.isShow = false
        })
    }

    @action
    closeBox = () => {
        this.modal = false
        this.editFields = {}
    }

    /***
     * 点击左边目录树显示右边数据
     */
    @action
    clickRow = async (record) => {
        this.loading = true
        this.rowData = record
        this.dragList = []
       if (record.level===1) {
           const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/type/lv1BelowCatalog/${record.id}`,{
               page: this.categoryPagination.current?this.categoryPagination.current-1:0,
               size: 10
           })
        runInAction(() => {
            if (res.status === 0) {
                this.loading = false
                return
            }
            this.isShow = true
            this.dragList = Array.isArray(res.content) ? res.content : []
            this.categoryPagination = {
                current: res.number + 1,
                total: res.totalElements
            }
            this.loading = false
        })}
       else {
           this.isShow = true
           this.dragList.push({
               name:record.name,
               code: record.code,
               id: record.id,
               level: record.level,
               pId: record.pId,
               sort: record.sort,
               judgmentToDelete: record.judgmentToDelete
           })
           this.categoryPagination = {
               current: 1,
               total: 1
           }
           this.loading = false
       }
       this.loading = false
    }

    //Delete CatalogId
    @action
    deleteOne = async (record) => {
        this.loading = true
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/type/delete/${record.id}`)
        runInAction(() => {
            if (res.status === 0) {
                this.loading = false
                message.warn('该分类下有商品，请勿删除！')
                return
            }
            message.success('删除成功')
            this.getList()
            if (record.level===2) {
                if (this.dragList.length===1) {
                    let obj = {
                        id: record.pId,
                        level: 1
                    }
                    this.clickRow(obj)
                } else {
                    this.rowData.id && this.clickRow(this.rowData)
                }
            } else {
                this.initGetRightTable()
            }
            this.loading = false
        })
    }

    /**
     * 展开的行变化时触发
     * @param expandedRows
     */
    @action
    changeExpandedLeftRowKeys = (expandedRows) => {
        this.expandedLeftRowKeys = expandedRows
    }

    /***
     * 保存排序
     * @returns {Promise<void>}
     */
    @action
    saveSort = async () => {
        let dragList = []
        this.dragList.forEach((item, index) => {
            dragList.push({
                id: item.id,
                sort: index + 1
            })
        })
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/type/modifySort`, dragList)
        runInAction(() => {
            if (res && res.status === 0) {
                return
            }
            this.dragState = false
        })
        await this.getList()
        this.rowData.id && await this.clickRow(this.rowData)
    }

    @action
    blurCode = async () => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/boutique/type/determineWhetherTheCodeAlreadyExists/`,{
            code: this.editFields.code,
            id: this.id?this.id:''
        })
        runInAction(()=> {
           if (res.code!==null) {
               this.editFields.code = ''
               return message.warn('此编号已存在，请重新输入')
           }
        })
    }
}

export default new BoutiqueTypeStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/BoutiqueCatalog/BoutiqueType/store.js